import React from 'react';

const IconStar = ({ onClick, color = '#141029' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" onClick={onClick}>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0L24 0 24 24 0 24z" transform="translate(-3 -3)" />
      <path fill={color} fillRule="nonzero" d="M19.65 9.04l-4.84-.42-1.89-4.45c-.34-.81-1.5-.81-1.84 0L9.19 8.63l-4.83.41c-.88.07-1.24 1.17-.57 1.75l3.67 3.18-1.1 4.72c-.2.86.73 1.54 1.49 1.08l4.15-2.5 4.15 2.51c.76.46 1.69-.22 1.49-1.08l-1.1-4.73 3.67-3.18c.67-.58.32-1.68-.56-1.75zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z" transform="translate(-3 -3)" />
    </g>
  </svg>
);

export default IconStar;
